import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-credit card 216",
  "use": "icon-credit card 216-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-credit card 216\"><path d=\"M789.333333 234.666667a64 64 0 0 1 64 64v426.666666a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V298.666667a64 64 0 0 1 64-64h554.666666z m0 64H234.666667v426.666666h554.666666V298.666667zM384 618.666667v64h-106.666667v-64h106.666667z m362.666667-213.333334v64H277.333333v-64h469.333334z\" p-id=\"16991\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol